import axios from 'axios';

class ProviderOptions {
  getOptions() {
    return axios.get('https://api.therenceguillerme.fr/wp-json/acf/v3/options/acf-options-page');
  }
}

export default new ProviderOptions();
